var site = site || {};

(function ($) {
  Drupal.behaviors.productAccordionV1 = {
    attach: function (context, settings) {
      var $accordianWrapper = $('.product-full__accordion', context);
      var $accoridanTitle = $('.js-accordion__title', context);
      var $accoridanBody = $('.js-accordian__body', context);

      $accoridanTitle.once().on('click', function () {
        var $self = $(this);

        $self.parent().toggleClass('active');
      });

      if (site.client.isMobile) {
        $accordianWrapper.css('background', 'none');
      }
    }
  };
})(jQuery);
